module.exports = __webpack_public_path__ + "img/nissan-New.53377640.png";